import JWT from '@tv2/lib-core/jwt';
import { type ChromecastUser } from '@tv2-player/unifiedplayer/src/types/ChromecastUser';
import type { ChromecastPlayRequestCustomData } from '../types';
import getIds from './getIds';

export function getChromecastUser(customData: ChromecastPlayRequestCustomData): ChromecastUser {
  const ids = getIds(customData.accessToken, customData.userId ?? 'anonymous');
  const userInformation = getUserInfoFromToken(customData.userIdToken);

  return {
    accessToken: customData.accessToken,
    userId: ids.userId!,
    userEmail: userInformation.email,
    appVersion: customData.appVersion,
    platform: customData.platform,
    device: {
      deviceUid: customData.deviceUid,
      deviceName: customData.deviceName,
      deviceType: customData.deviceType,
    },
    npawId: ids.npawId,
    adobeId: ids.adobeId,
    resettableDeviceId: customData.resettableDeviceId,
    adTrackingLimited: customData.adTrackingLimited,
    resettableDeviceIdType: customData.resettableDeviceIdType,
    selectedProfile: customData.profile,
  };
}

function getUserInfoFromToken(token: string | undefined) {
  const defaultUser = { email: '' };

  if (!token || !JWT.isJWT(token)) return defaultUser;

  const parsedToken = JWT.parse(token) as Record<string, string>;
  return {
    ...defaultUser,
    email: parsedToken.email || '',
  };
}
